import { createSelector } from "reselect";

const ecoSettings = (state) => state.ecoSettings;

export const getEcoSettingByKey = (key) => {
	return createSelector(ecoSettings, (selectedEcoSettings) => {
		return selectedEcoSettings?.find((setting) => setting.key === key)?.value || false;
	});
};

export const getEcosettingsValueByKey = createSelector([ecoSettings], (items) => (key) => {
	const selectedItem = items.find((item) => item.key === key);

	return selectedItem ? selectedItem.value : null;
});
